import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CanvasElementComponent } from '../../canvas-elements/element-component';
import { CanvasElementBaseComponent } from '../__base/base.component';

@Component({
  selector: 'be-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
// TODO: test
export class WrapperComponent
  extends CanvasElementBaseComponent<'wrapper'>
  implements CanvasElementComponent<'wrapper'> {}
